import React from 'react'
import PropTypes from 'prop-types'
import styles from './LoginSettings.module.scss'
import classnames from 'classnames'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

const LoginSettings = (props) => {
  const {
    user
  } = props

  const digitalRedirectUrl = `${process.env.REACT_APP_DIGITAL_CLIENT_HOST}/dashboard?redirect_from_pwm=true`

  const redirectToDigital = () => window.location = digitalRedirectUrl

  const digitalLoginVisibility = user.giveDigitalAccess ? {} : { display: 'none' }

  return (
    <div className={styles.container}>
      <p className={styles.header}>
        If you need to change your login details,
        please <PrivateWealthEmailLink message="contact your team" />.
      </p>
      <div className={styles.infoRow}>
        <div className={styles.fullColumn}>
          <label>current email</label>
          <div className={styles.text} data-test-id="personEmail">{user.personEmail}</div>
        </div>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.fullColumn}>
          <label>current password</label>
          <div className={styles.text} data-test-id="personPassword">**********</div>
        </div>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.fullColumn}>
          <div
            className={styles.loginLabel}
            style={digitalLoginVisibility}>
            Need to access your Ellevest Digital account?
          </div>
          <div
            className={styles.loginText}
            data-test-id="loginText"
            style={digitalLoginVisibility}>
             Click the button below to be redirected to log in to your Ellevest Digital account.
          </div>
          <button
            type="button"
            className={classnames('button button--primary', styles.loginButton)}
            onClick={redirectToDigital}
            style={digitalLoginVisibility}>
            Log in to digital
          </button>
        </div>
      </div>
    </div>
  )
}

LoginSettings.defaultProps = {
  user: {}
}

LoginSettings.propTypes = {
  user: PropTypes.object
}

export default LoginSettings



// WEBPACK FOOTER //
// ./src/components/Client/LoginSettings/LoginSettings.jsx